<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <form
    [formGroup]="form"
    #f="ngForm">
    <div class="grid">
      <div class="col-3">
        <p-select
          [options]="shops"
          formControlName="shopType"
          optionLabel="label"></p-select>
      </div>
      <div class="col-3">
        <div class="custom-iconfield">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="input-full"
            formControlName="shopCode"
            pInputText
            placeholder="ショップIDを入力（必須）"
            [disabled]="isDoingCrawl()" />
        </div>
      </div>

      <div class="col-6">
        @if (isShopCodeRequired()) {
          <p-message severity="error">ショップIDは必須です</p-message>
        }
        <p-button
          label="検索"
          icon="pi pi-search"
          (onClick)="doSearch()"
          [disabled]="form.invalid || isDoingCrawl()"></p-button>
      </div>

      <div class="col-12">
        <p-panel
          header="詳細検索"
          [toggleable]="false"
          [collapsed]="false">
          <h4>価格絞り込み</h4>
          <br />
          <div class="grid">
            <div class="col-3">
              <span class="p-float-label">
                <input
                  type="number"
                  id="minPrice"
                  formControlName="minPrice"
                  pInputText />
                <label for="minPrice">最小価格</label>
              </span>
            </div>
            <div class="col-3">
              <span class="p-float-label">
                <input
                  type="number"
                  id="maxPrice"
                  formControlName="maxPrice"
                  pInputText />
                <label for="maxPrice">最大価格</label>
              </span>
            </div>
            <div class="col-3">
              <span class="p-float-label">
                <input
                  type="number"
                  id="minGross"
                  formControlName="minGross"
                  pInputText />
                <label for="minPrice">最小の粗利</label>
              </span>
            </div>
            <div class="col-3">
              <span class="p-float-label">
                <input
                  type="number"
                  id="minProfitRate"
                  formControlName="minProfitRate"
                  pInputText />
                <label for="minPrice">最小の利益率(1~100)</label>
              </span>
            </div>
          </div>

          <h4>Amazon絞り込み</h4>
          <br />
          <div class="grid">
            <div class="col-6">
              <span class="p-float-label">
                <input
                  type="number"
                  id="minRanking"
                  formControlName="minRanking"
                  pInputText />
                <label for="minPrice">最小Amazonランキング</label>
              </span>
            </div>
            <div class="col-6">
              <p-select
                [options]="hasNewProducts"
                formControlName="hasNewProduct"
                optionLabel="label"
                [showClear]="true"
                placeholder="Amazon新品出品者"></p-select>
            </div>
          </div>
        </p-panel>
      </div>

      <div class="col-6">
        <p-button
          styleClass="p-button-danger"
          label="クローリング開始"
          icon="pi pi-search"
          (onClick)="confirm()"
          [disabled]="!canCrawling()"></p-button>
      </div>

      <div class="col-6">
        <p-button
          styleClass="p-button-warning"
          label="CSVダウンロード"
          icon="pi pi-search"
          (onClick)="doDownload()"
          [disabled]="!canDownload()"></p-button>
        <a id="csv-donwload"></a>
      </div>
    </div>
  </form>
</p-panel>

@if (isDoingCrawl()) {
  <div>
    <p-progressbar
      mode="indeterminate"
      [style]="{ height: '2px' }"></p-progressbar>
    @for (m of crawlingMessages; track $index) {
      <p-message [severity]="m.severity">
        <b>{{ m.summary }}</b>
        {{ m.detail }}
      </p-message>
    }
  </div>
}

@if (isShowErrorMessage()) {
  <div>
    <p-message severity="warn">
      <div style="padding-left: 10px">
        <b>他の人がクローリング中</b>
        <br />
        他の人がクローリング中です。しばらく時間をおいて実行をお願いします。
        <br />
        しばらくこのメッセージが継続して表示される場合は管理者までお問い合わせをお願いします。
      </div>
    </p-message>
  </div>
}

@if (canShowShop()) {
  <div class="grid">
    <div class="col-4">
      <p-card
        subheader="{{ targetShop.shopCode }} のショップ名"
        [style]="{ height: '180px' }">
        <div class="grid">
          <div class="col-8">
            @if (hasLink()) {
              <h2>
                <a
                  href="{{ targetShop.shopUrl }}"
                  target="_blank">
                  {{ targetShop.shopName }}
                </a>
              </h2>
            }
            @if (!hasLink()) {
              <h2>
                {{ targetShop.shopName }}
              </h2>
            }
          </div>
          <div class="col-4">
            <b>前回実行時</b>
            <div>最小価格: {{ targetShop.latestMinPrice | number }} 円</div>
            <div>最大価格: {{ targetShop.latestMaxPrice | number }} 円</div>
          </div>
        </div>
      </p-card>
    </div>
    <div class="col-2">
      <p-card
        subheader="最終更新 開始 日時"
        [style]="{ height: '180px' }">
        <h2>{{ getLatestStarted() }}</h2>
      </p-card>
    </div>
    <div class="col-2">
      <p-card
        subheader="最終更新 完了 日時"
        [style]="{ height: '180px' }">
        <h2>{{ getLatestEnded() }}</h2>
      </p-card>
    </div>
    <div class="col-2">
      <p-card
        subheader="登録済み商品数"
        [style]="{ height: '180px' }">
        <div>
          ショップ:
          <b>
            <font size="5">{{ targetShop.totalProductNum }}</font>
          </b>
        </div>
        <div>
          アマゾン:
          <b>
            <font size="5">{{ targetShop.totalAmazonNum }}</font>
          </b>
        </div>
      </p-card>
    </div>
    <div class="col-2">
      <p-card
        subheader="更新商品数"
        [style]="{ height: '180px' }">
        <div>
          ショップ:
          <b>
            <font size="5">{{ targetShop.updatedProductNum }}</font>
          </b>
        </div>
        <div>
          アマゾン:
          <b>
            <font size="5">{{ targetShop.updatedAmazonNum }}</font>
          </b>
        </div>
      </p-card>
    </div>
  </div>
}

<p-dialog
  header="最終確認"
  [(visible)]="isDisplayModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false">
  <p>スクレイピングを開始してもよろしいでしょうか？</p>
  <p>（時間がかかる場合があります）</p>
  <ng-template #footer>
    <!-- p-dialog は開くとフッタの先頭にフォーカスを当てる。Enter 1 回で実行されないようキャンセルを先に置く -->
    <button
      type="button"
      pButton
      (click)="isDisplayModal = false"
      class="p-button-secondary">
      <i
        class="pi pi-times"
        aria-hidden="true"></i>
      キャンセル
    </button>
    <button
      type="button"
      pButton
      (click)="doCrawling()">
      <i
        class="pi pi-check"
        aria-hidden="true"></i>
      クローリング実行
    </button>
  </ng-template>
</p-dialog>
